import React from "react";

export const emptyArray = [];
export const emptyObject = {};
export const emptyString = "";
export const emptyFunction = () => {};
export const emptyComponent = <></>;
